export default __webpack_public_path__ + "static/studyoffice-study5-330a7fade4214976afd3d0c025283441.jpg";